export const translationKeyMap = {
  "ParkingHasBeenSelection": "backendKey.ParkingHasBeenSelection",
  "BookingHasBeenSelected": "backendKey.BookingHasBeenSelected",
  "ParkingWasNotFound": "backendKey.ParkingWasNotFound",
};
